module.exports = __webpack_public_path__ + "static/media/icon-piece4-1.9c51b04e.png";